import { call, put } from 'redux-saga/effects';

import * as Actions from '../actions';
import * as D from '../deps';
import * as Utils from '../utils';

export function* generateAndGotoBranchLink({ payload }) {
  const { error, link } = yield call(D.DesktopAppUtils.generateBranchLink, payload);
  if (error) {
    yield call(Utils.logBranchError, error);
    return;
  }
  yield put(Actions.setDeepLinkPath(link));
  yield put(Actions.setSourcePath(payload.deepLinkSourcePath));
  yield put(D.AppActions.externalRedirect(link));
}
